
export const convertDateFormat = (dateStr: string): string => {
  if (!dateStr) return "";
  
  try {
    const [day, month, year] = dateStr.split('/');
    
    const monthMap: Record<string, string> = {
      'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
      'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
      'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
    };
    
    const monthNumber = monthMap[month];
    
    if (!monthNumber || !day || !year) {
      return "";
    }
    
    return `${year}-${monthNumber}-${day.padStart(2, '0')}`;
  } catch (e) {
    return "";
  }
};